import { InjectionToken } from '@angular/core';

const productTranslations = {
  CentralAdmin: $localize`Central Admin`,
  Workflow: $localize`Workflowᴿᵀ`,
  DisplayBoards: $localize`Screensᴿᵀ`,
  Kiosks: $localize`Kiosksᴿᵀ`,
  Assets: $localize`Assetsᴿᵀ`,
  Pulse: $localize`Pulseᴿᵀ`,
  Connect: $localize`Connectᴿᵀ`,
  HandHygiene: $localize`Hand Hygieneᴿᵀ`,
  MapManager: $localize`Mapsᴿᵀ`,
  Duress: $localize`Duressᴿᵀ`,
  Integrate: $localize`Integrateᴿᵀ`
} as const;

export type Product = keyof typeof productTranslations;
export type ProductTranslations = { [key in Product]: string };

const PRODUCT_TRANSLATIONS: ProductTranslations = { ...productTranslations };
export const ProductTranslations = new InjectionToken('PRODUCT_TRANSLATIONS')
export const ProductProvider = { provide: ProductTranslations, useValue: PRODUCT_TRANSLATIONS }
